export default __webpack_public_path__ + "static/media/otherChannel.5082f1b0.png";